import React from "react";

import "./TableCell.css";

export default function TableCell(props){
    return (
        <td className = {`admin-panel-table-cell ${props.className}`}>{props.children}</td>
    );

}